import React, { useState, useEffect, useContext } from "react";
import { TextField, InputAdornment, IconButton } from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Box from "@mui/material/Box";
import { validation } from "../Utilities/validations";
import consts from '../Utilities/appConsts.json';
import { LanguageContext } from "../language/LanguageContext";


export default function Input(props) {
  const { getTranslation } = useContext(LanguageContext);
  const [value, setValue] = useState(props.value ? props.value : "");
  const [isError, setIsError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [focused, setFocused] = useState(false);
  const characterLimit = props.characterLimit;
  const isPasswordInput = props.type === "password"; // Determine if it's a password input
  const [showPassword, setShowPassword] = useState(false);

  const chracterLimitHelperText = (value) => {
    if ((value.length < characterLimit + 1)) {
      return isPasswordInput ? (
        <Box className="font_xs position_text_align_end">
          {value.length}/{characterLimit}
        </Box>
      ) : null;
    } else {
      return (
        <Box className="position_flex_row_space_between position_flex_direction_row_reverse">
          <Box className="font_xs position_text_align_end">
            {value.length}/{characterLimit}
          </Box>
          <Box className="font_xs color_red">
            {"הגעת למקסימום התווים"}
          </Box>
        </Box>
      );
    }
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleTogglePasswordKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleTogglePasswordVisibility();
    }
  };
  
  const handlePaste = (event) => {
    event.preventDefault(); // Prevent the default paste behavior
  };

  const handleChange = (event) => {
    if (props.onlyNumber === true) {
      if (!isNaN(event.target.value)) {
        // It's a number, you can set the value
        setValue(event.target.value);
      }
    } else {
      setValue(event.target.value);
    }
    if(props.isComeFromLogin){
      props.name ? props.setValue(props.name, event.target.value) : props.setValue(event.target.value);
    }
  };

  const handleBlur = () => {
    setFocused(false);    
    const validationInfo = validation(value, props.label);
    if (props.name) {
     validationInfo.isError ? props.setValue(props.name , value, null) : props.setValue(props.name , value, props.setShowHelperText);
    }
    else {
      props.setValue(value);
    }

    props.helperText !==(consts.DISABLED) && setHelperText(validationInfo.isError ? <Box className='color_red font_xs'>{validationInfo.helperText}</Box> : ((!props.onlyNumber) &&chracterLimitHelperText(value)));
    setIsError(validationInfo.isError);
    if (props.setIsError) {
      props.setIsError(validationInfo.isError, props.name);
    }
  };

  const handleFocus = () => {
    setFocused(true);
  };

  useEffect(() => {
    setIsError(props.showHelperText);
  }, [props.showHelperText]);

  useEffect(() => {
    setHelperText(props.helperText ? <Box className='color_red font_xs'>{props.helperText}</Box> : "");
  },[props.helperText]);

  const isConfirmPasswordField = props.name === "secondPassword";
  const showLabelKey = isConfirmPasswordField
    ? consts.SHOW_CONFIRM_PASSWORD_LABEL
    : consts.SHOW_PASSWORD_LABEL;
  const hideLabelKey = isConfirmPasswordField
    ? consts.HIDE_CONFIRM_PASSWORD_LABEL
    : consts.HIDE_PASSWORD_LABEL;
  const togglePasswordLabel = getTranslation(showPassword ? hideLabelKey : showLabelKey);
  const passwordAdornment = props.endAdornment && isPasswordInput ? (
    <InputAdornment position="end" sx={{ paddingRight: 0 }}>
      <IconButton
        sx={{
          '&:hover': {
            bgcolor: 'transparent',
            minWidth: 'auto',
          },
          padding: 0,
        }}
        aria-label={togglePasswordLabel}
        aria-pressed={showPassword}
        onClick={handleTogglePasswordVisibility}
        onKeyDown={handleTogglePasswordKeyDown}
        onMouseDown={(event) => event.preventDefault()}
        edge="end"
      >
        {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </InputAdornment>
  ) : undefined;

  return (
    <Box >
        <TextField
          className={props.className ? props.className : ""}
          value={value}
          type={isPasswordInput ? (showPassword ? 'text' : 'password') : 'text'}
          label={props.label}
          onPaste={props.name == 'secondPassword' ? handlePaste : undefined}
          data-testid={props.testid}
          variant={props?.variant ? props.variant : "filled"}
          inputProps={{
            maxLength: characterLimit + 1,
            sx: { direction: isPasswordInput ? "ltr" : "rtl", textAlign: isPasswordInput && "end"}
          }}
          helperText={props.helperText !==(consts.DISABLED) && (helperText || (props.showHelperText && props.helperText))}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={handleChange}
          required={props.isRequired} 
          error={isError ||  ((!props.onlyNumber) && value.length >=  characterLimit + 1)}
          InputLabelProps={{
            variant: "filled",
            style: { color: '#568100', direction: "rtl" },
        }}
        InputProps={
          {
            endAdornment: passwordAdornment
          }
        }
        style={{
          width: '100%', // Set width to 100% to occupy the available space
        }}
        />

    </Box>
  );
}
